//common
import { useLoaderData, useNavigate } from "react-router-dom";
import { AbandonedVehicleRun } from "./api/Application";
import { showInstantLocalDate, showInstantLocalDateTime, showInstantLocalTime } from "./api/Date";
import { thumbnailUrl } from "./api/Url";
import { ImageBlendCanvas } from "./components/ImageBlendCanvas";

interface AbandonedVehicleRunItemProps {
    run:     AbandonedVehicleRun;
    onClick: () => void;
}

function AbandonedVehicleRunItem( { run, onClick }: AbandonedVehicleRunItemProps ) {
    return <div className="d-flex p-3 border shadow rounded-3"
        style={{ cursor: "pointer" }}
        onClick={onClick}>
        <div className="me-3 d-flex flex-column flex-shrink-0">
            <ImageBlendCanvas width={128} height={128} 
                imageA={thumbnailUrl(run.aerialImageBeforeId, 128)}
                imageB={thumbnailUrl(run.aerialImageAfterId,  128)}
            />
        </div>
        <div className="d-flex flex-column gap-1 px-1">
            <div className="fs-4">Run #{run.abandonedVehicleRunId}</div>
            <div className="">
                1: {showInstantLocalDate( run.before.capturedWhen  )}
            </div>
            <div>
                2: {showInstantLocalDate( run.after.capturedWhen )}
            </div>
        </div>
    </div>;
}

export function AbandonedVehicleRunListPage() {
    const runs = useLoaderData() as AbandonedVehicleRun[] ?? [];
    const nav  = useNavigate();
    return <div className="h-100">
        <div id="capture-list-page">
            <div id="capture-list" style={{ display: "grid", gridTemplateRows: "max-content 1fr" }}>
                <div className="bg-body-tertiary border-bottom flex-row w-100 gap-2 p-2">
                    <div className="flex-grow-1 ps-2 fs-5">
                        Abandoned Vehicle Detection
                    </div>
                </div>
                <div className="y-scroll-auto w-100 p-2">
                    {runs.map( run => <AbandonedVehicleRunItem 
                        key={run.abandonedVehicleRunId}
                        run={run}
                        onClick={ () => nav( `/detect/${run.abandonedVehicleRunId}`)}
                        /> )}
                </div>
            </div>
            <div className="image-viewer h-100 overflow-hidden position-relative" style={{ backgroundColor: "black" }}>

            </div>
        </div>
    </div>;
}